/**
 * Notification service for managing user notifications
 */
import apiClient from './apiClient';

export const notificationService = {
  /**
   * Get all notifications with pagination
   * @param {Object} params - Query parameters (type, page, limit)
   * @returns {Promise} Notifications list with pagination
   */
  getAll: async (params = {}) => {
    return apiClient.get('/notifications', params);
  },

  /**
   * Get single notification by ID
   * @param {number} id - Notification ID
   * @returns {Promise} Notification details
   */
  getById: async (id) => {
    return apiClient.get(`/notifications/${id}`);
  },

  /**
   * Get unread notification count
   * @returns {Promise} Unread count
   */
  getUnreadCount: async () => {
    return apiClient.get('/notifications/unread-count');
  },

  /**
   * Mark notification as read
   * @param {number} id - Notification ID
   * @returns {Promise} Updated notification
   */
  markAsRead: async (id) => {
    return apiClient.put(`/notifications/${id}/read`);
  },

  /**
   * Mark all notifications as read
   * @returns {Promise} Success message
   */
  markAllAsRead: async () => {
    return apiClient.put('/notifications/mark-all-read');
  },

  /**
   * Delete notification
   * @param {number} id - Notification ID
   * @returns {Promise} Success message
   */
  delete: async (id) => {
    return apiClient.delete(`/notifications/${id}`);
  },

  /**
   * Delete all notifications
   * @returns {Promise} Success message
   */
  deleteAll: async () => {
    return apiClient.delete('/notifications');
  },

  /**
   * Perform bulk action on notifications
   * @param {string} action - Action type (mark_read, delete)
   * @param {Array} notificationIds - Array of notification IDs
   * @returns {Promise} Success message
   */
  bulkAction: async (action, notificationIds) => {
    return apiClient.post('/notifications/bulk-action', {
      action,
      notificationIds
    });
  }
};

export default notificationService;
